import { render } from "./DownloadPanelModal.vue?vue&type=template&id=3bef8052&scoped=true"
import script from "./DownloadPanelModal.vue?vue&type=script&lang=js"
export * from "./DownloadPanelModal.vue?vue&type=script&lang=js"

import "./DownloadPanelModal.scss?vue&type=style&index=0&id=3bef8052&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bef8052"]])

export default __exports__